module.exports = __webpack_public_path__ + "static/media/game-press-symbol-polar.e7e99c4c.png";